export default __webpack_public_path__ + "static/media/blog-img73.3e1a2871.jpg";